module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/export-to-machine/export-to-machine.component.css
// module id = ./src/app/general-transaction/export-to-machine/export-to-machine.component.css
// module chunks = main